import { forwardRef, ReactElement, Ref } from "react";
import { EditGenericWithDestinationWindowTile, EditGenericWithDestinationWindowTilePropsBase } from "./EditGenericWithDestinationWindowTile";
import { EditTileHandle } from "./EditTile";
import { SharePointDetailsTileModel, updateSharePointTile } from "client/Api/Workspace/workspace";

export type EditSharePointTileProps = EditGenericWithDestinationWindowTilePropsBase<SharePointDetailsTileModel>;

export const EditSharePointTile = forwardRef(
	(props: EditSharePointTileProps, ref: Ref<EditTileHandle>): ReactElement => {

		return (
			<EditGenericWithDestinationWindowTile
				{...props}
				requestHandler={updateSharePointTile}
				ref={ref}
			/>
		);
	}
);
EditSharePointTile.displayName = "EditSharePointTile";
